/**
 * Temporary mapping from Course ID to Curriculum ID.
 * This is used as a fallback when the backend CourseDetail response usually doesn't include curriculumId.
 * Generated from backend data.
 */

// Mapping of Course ID -> Curriculum ID
const COURSE_TO_CURRICULUM: Record<number, number> = {
    // Shared Courses (MASTER/PRIME) - prioritizing Crcl-C (1180) based on script output order, 
    // but let's try to be smart. 
    // If we assume most users might be on the newer curricula, this is fine.
    "598": 1180,
    "599": 1180,
    "600": 1180,
    "601": 1180,

    // Crcl-A Exclusive
    "602": 605,
    "603": 605,
    "604": 605,

    // Crcl-B Exclusive
    "1178": 1168,
    "1179": 1168,

    // Crcl-C Exclusive
    "1177": 1180,

    // Other Curricula
    "1169": 1681,
    "1170": 1946,
    "1171": 1523,
    "1172": 1189,
    "1173": 2166,
    "1174": 2163,
    "1175": 2153,
    "1176": 2165
};

export const getCurriculumIdForCourse = (courseId: number): number | null => {
    return COURSE_TO_CURRICULUM[courseId] || null;
}
